/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

 @import "../../scss/vars";
 @import "../../scss/gts";

:host {
  & > div {
    width: 100%;
    height: 100%;

    & > div {
      width: 100%;
      height: 100%;
    }
  }

  .wv-tooltip {
    max-width: 300px;

    div {
      word-wrap: anywhere;
    }
  }
  
  .gts-classname {
    font-size: var(--warp-view-font-size, 14px);
  }

  .gts-labelname {
    font-size: var(--warp-view-font-size, 14px);
  }

  .gts-attrname {
    font-size: var(--warp-view-font-size, 14px);
  }

  .gts-separator {
    font-size: var(--warp-view-font-size, 14px);
  }

  .gts-labelvalue {
    font-size: var(--warp-view-font-size, 14px);
  }

  .gts-attrvalue {
    font-size: var(--warp-view-font-size, 14px);
  }

}
